"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _Checkbox2 = _interopRequireDefault(require("./Checkbox.style"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
var _constants = require("./constants");
var _excluded = ["checkedLabel", "disabled", "name", "checked", "showLabel", "uncheckedLabel", "className", "onChange", "tabIndex", "value", "id", "type", "label", "hasError", "placeholder"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Checkbox = /*#__PURE__*/function (_PureComponent) {
  function Checkbox() {
    var _this;
    _classCallCheck(this, Checkbox);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Checkbox, [].concat(args));
    _defineProperty(_this, "handleInputChange", function (event) {
      var checked = event.target.checked;
      if (_this.props.onChange) {
        _this.props.onChange(event, checked);
      }
    });
    return _this;
  }
  _inherits(Checkbox, _PureComponent);
  return _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        checkedLabel = _this$props.checkedLabel,
        disabled = _this$props.disabled,
        name = _this$props.name,
        checked = _this$props.checked,
        showLabel = _this$props.showLabel,
        uncheckedLabel = _this$props.uncheckedLabel,
        className = _this$props.className,
        onChange = _this$props.onChange,
        tabIndex = _this$props.tabIndex,
        value = _this$props.value,
        id = _this$props.id,
        type = _this$props.type,
        label = _this$props.label,
        hasError = _this$props.hasError,
        placeholder = _this$props.placeholder,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      var icon = checked ? _constants.ICON_CHECKED : _constants.ICON_UNCHECKED;
      var switchLabel = checked ? checkedLabel : uncheckedLabel;
      return /*#__PURE__*/_react["default"].createElement(_Checkbox2["default"], _extends({
        type: type,
        onChange: this.handleInputChange,
        className: "checkbox-wrapper",
        disabled: disabled,
        checked: checked,
        hasError: hasError
      }, otherProps), /*#__PURE__*/_react["default"].createElement("input", {
        type: "checkbox",
        disabled: disabled,
        name: name,
        id: id,
        checked: checked,
        className: className,
        tabIndex: tabIndex,
        value: value,
        placeholder: placeholder,
        readOnly: true
      }), type === _constants.checkboxTypes.normal ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: "checkbox-icon",
        icon: icon
      }), label && /*#__PURE__*/_react["default"].createElement("span", {
        className: "checkbox-label"
      }, label)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "checkbox-thumb"
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "checkbox-switch-label"
      }, showLabel ? switchLabel : '')));
    }
  }]);
}(_react.PureComponent);
Checkbox.propTypes = {
  showLabel: _propTypes["default"].bool,
  checkedLabel: _propTypes["default"].string,
  uncheckedLabel: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(R.keys(_constants.checkboxTypes)),
  label: _propTypes["default"].string,
  hasError: _propTypes["default"].bool,
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  /**
   * The css classes for the checkbox element
   */
  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   * The id of the `checkbox` element.
   */
  id: _propTypes["default"].string,
  /*
   * The name attribute of the checkbox element
   */
  name: _propTypes["default"].string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes["default"].func,
  /**
   * The tab index of the checkbox element
   */
  tabIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  /**
   * The value of the component.
   */
  value: _propTypes["default"].string,
  placeholder: _propTypes["default"].string
};
Checkbox.defaultProps = {
  showLabel: false,
  checkedLabel: 'Yes',
  uncheckedLabel: 'No',
  type: _constants.checkboxTypes.normal,
  checked: undefined,
  className: undefined,
  disabled: false,
  id: undefined,
  name: undefined,
  onChange: null,
  tabIndex: null,
  value: undefined,
  label: undefined,
  hasError: false,
  placeholder: undefined
};
var _default = exports["default"] = Checkbox;